module.exports = __webpack_public_path__ + "img/数字孪生.3b499d02.png";